import http from "./http-common";
import { getAuthToken } from "./authService";
import { collection, getDocs } from "firebase/firestore";
import { firestore } from "@/firebase/firebase";

const createUser = async (user) => {
  try {
    const token = await getAuthToken();
    console.log("User token is: ", token);

    // Make the request with the token in the Authorization header
    const response = await http.put("api/v1/user", user, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Pass the token here
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

const getUsers = async () => {
  try {
    const usersCollection = collection(firestore, "users");
    const snapshot = await getDocs(usersCollection);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

const deleteUser = async (userId) => {
  const token = await getAuthToken();

  try {
    const response = await http.delete('/api/v1/user/' + userId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;  // Returning the status code of the deletion
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

const changeUserInfo = async (userId, payload) => {
  const token = await getAuthToken();

  try {
    const response = await http.patch(`/api/v1/user/${userId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

// Unauthenticated — used by the "Forgot Password?" page. The backend always
// answers 200 and never reveals whether the account exists.
const requestPasswordReset = async (email) => {
  const response = await http.post("/api/v1/auth/password-reset", { email });
  return response;
};

const setTemporaryPassword = async (userId) => {
  const token = await getAuthToken();

  try {
    const response = await http.post(`/api/v1/user/${userId}/set-password`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error setting temporary password:", error);
    throw error;
  }
};

const sendPasswordReset = async (userId) => {
  const token = await getAuthToken();

  try {
    const response = await http.post(`/api/v1/user/${userId}/reset-password`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending password reset:", error);
    throw error;
  }
};

const disableUser = async (userId) => {
  const token = await getAuthToken();

  try {
    const response = await http.post(`/api/v1/user/${userId}/disable`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error disabling user:", error);
    throw error;
  }
};

const enableUser = async (userId) => {
  const token = await getAuthToken();

  try {
    const response = await http.post(`/api/v1/user/${userId}/enable`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error enabling user:", error);
    throw error;
  }
};

const UserService = {
  createUser,
  getUsers,
  deleteUser,
  changeUserInfo,
  sendPasswordReset,
  requestPasswordReset,
  setTemporaryPassword,
  disableUser,
  enableUser,
};

export default UserService;
